// Every key is listed here so that mutations can invalidate exactly what they affect
export const queryKeys = {
    me: ["me"] as const,
    reports: ["reports"] as const,
    reportsForWeeks: (weeksToLoad: number) => ["reports", weeksToLoad] as const,
    projects: ["projects"] as const,
    projectsWithDetails: ["projectsWithDetails"] as const,
    projectsWithDetailsForView: (viewId: number) => ["projectsWithDetails", viewId] as const,
    projectDetail: ["project"] as const,
    project: (id: string) => ["project", id] as const,
    customers: ["customers"] as const,
    tasks: ["tasks"] as const,
    tasksForView: (viewId: number) => ["tasks", viewId] as const,
    taskDetail: ["task"] as const,
    task: (id: string) => ["task", id] as const,
    users: ["users"] as const,
    tools: ["tools"] as const,
    dashboard: ["dashboard"] as const,
    dashboardForWeek: (startOfWeek: string) => ["dashboard", startOfWeek] as const,
    dashboardMonth: ["dashboardMonth"] as const,
    dashboardMonthForMonth: (startOfMonth: string) => ["dashboardMonth", startOfMonth] as const
};
